import React, { useEffect } from "react";
import { DISCLAIMER, CONTACT_EMAIL } from "../constants/disclaimer";

export default function Disclaimer() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="disclaimer-page">
      <p className="text-xs font-bold tracking-widest uppercase text-coral">Legal</p>
      <h1 className="mt-2 font-heading text-4xl sm:text-5xl font-black text-ink">Disclaimer</h1>
      <p className="mt-3 text-ink-soft">
        Questions about this Disclaimer? Email{" "}
        <a href={`mailto:${CONTACT_EMAIL}`} data-testid="disclaimer-contact" className="font-bold text-coral hover:underline">{CONTACT_EMAIL}</a>.
      </p>
      <div className="mt-10 space-y-8" data-testid="disclaimer-content">
        {DISCLAIMER.map((s) => (
          <section key={s.n}>
            <h2 className="font-heading text-xl font-black text-ink">{s.n}. {s.h}</h2>
            {s.paras.map((p, i) => (
              <p key={i} className="mt-2 text-ink-soft leading-relaxed">{p}</p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
